// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3FoB5","title":"Info_title__2ygd3","links":"Info_links__3F689","link":"Info_link__2bVaP","logo":"Info_logo__2hoA2"};